export default (suggestionText, term, styles) => {
  return suggestionText
    .split(term)
    .map(match => {
      return `<span class='${styles.highlightedText}'>${match}</span>`
    })
    .join(`<span>${term}</span>`)
}
